export default __webpack_public_path__ + "static/ravi-1dc5dce16924029ae7f049d42982ff67.jpg";